const TOKEN_KEY = "afanasiev_user_token";

export const getUserToken = () => {
  try {
    return localStorage.getItem(TOKEN_KEY) || "";
  } catch {
    return "";
  }
};

export const setUserToken = (t) => {
  try {
    if (t) localStorage.setItem(TOKEN_KEY, t);
    else localStorage.removeItem(TOKEN_KEY);
  } catch {}
};

export const authHeaders = () => {
  const t = getUserToken();
  return t ? { Authorization: `Bearer ${t}` } : {};
};
